import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

const POIs = [
    {
        name: 'machine-1',
        position: { x: 31, y: -26, z: 0 },
        color: 'white',
        sound: {
            name: 'machine-1',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'machine-2',
        position: { x: 34, y: -27, z: 0 },
        color: 'white',
        sound: {
            name: 'machine-2',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'machine-3',
        position: { x: 35, y: -24, z: 0 },
        color: 'white',
        sound: {
            name: 'machine-3',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'machine-4',
        position: { x: 32, y: -23, z: 0 },
        color: 'white',
        sound: {
            name: 'machine-4',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'espace',
        position: { x: 33, y: -25, z: 0 },
        color: 'white',
        invisible: true,
        collision: {
            radius: 3,
        },
        onEnter() {
            triangle.drop('stonehenge-triangle-2', this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: { x: 3, y: -2 },
            });
        },
        onLeave() {
            audio.buffers.play('espace', {
                gain: 0,
            });
        },
    },
];

const sounds = [
    { name: 'machine-1', url: new URL('../../sound/Usine1.wav', import.meta.url) },
    { name: 'machine-2', url: new URL('../../sound/Usine2.wav', import.meta.url) },
    { name: 'machine-3', url: new URL('../../sound/Usine3.wav', import.meta.url) },
    { name: 'machine-4', url: new URL('../../sound/Usine4.wav', import.meta.url) },
    { name: 'espace', url: new URL('../../sound/Espace.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
